import React, { Component } from 'react';
import cx from 'classnames';

// Components
import Pictogram from './pictogram';
import TranslatedCopy from '../../intl/translated-copy';
import { getCMSUrl } from '../../constants/cms-urls';

class HeaderMenuMyTrips extends Component {
  render() {
    const bookClasses = cx({
      'HeaderMenuBook': true,
    });
    const {
      storefront,
    } = this.props;
    const [ 
      language,
      country,
    ] = storefront.split('-');
    return (
      <div className={ bookClasses }>
        <ul className='HeaderMenuBook-itemList'>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                href={ getCMSUrl(country, language, 'MANAGE_YOUR_BOOKING') } >
                <div className='HeaderMenuBook-content'>
                  <span className='HeaderMenuBook-itemIcon Icon Icon--baggage HeaderMenuBook-itemIcon--iconFont' />
                  <div className='HeaderMenuBook-wrapCopy'>
                    <TranslatedCopy
                      className='HeaderMenuBook-itemTitle'
                      copyID='APP_MY_TRIPS' />
                  </div>
                </div>
              </a>
            </div>
          </li>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                href={ getCMSUrl(country, language, 'TRIPS_EXTRAS') } >
                <div className='HeaderMenuBook-content'>
                  <span className='HeaderMenuBook-itemIcon Icon Icon--ancillaryInsurance HeaderMenuBook-itemIcon--iconFont' />
                  <div className='HeaderMenuBook-wrapCopy'>
                    <TranslatedCopy
                      className='HeaderMenuBook-itemTitle'
                      copyID='APP_EXTRAS' />
                  </div>
                </div>
              </a>
            </div>
          </li>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                href={ getCMSUrl(country, language, language === 'fr' ? 'HEADER_FOURTH_ITEM' : 'ECONOMY_PLUS') } >
                <div className='HeaderMenuBook-content'>
                  <span className='HeaderMenuBook-itemIcon Icon Icon--am-plus-white-outline HeaderMenuBook-itemIcon--iconFont' />
                  <div className='HeaderMenuBook-wrapCopy'>
                    <TranslatedCopy
                      className='HeaderMenuBook-itemTitle'
                      copyID={ language === 'fr' ? 'HEADER_FOURTH_ITEM' : 'ALT_LANGUAGE_AM_PLUS' } />
                  </div>
                </div>
              </a>
            </div>
          </li>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                href={ getCMSUrl(country, language, language === 'fr' ? 'HEADER_MYTRIPS_FOURTH_ITEM' : 'PREMIER_UPGRADE') } >
                <div className='HeaderMenuBook-content'>
                  <Pictogram className='HeaderMenuBook-itemIcon' id='flight' />
                  <div className='HeaderMenuBook-wrapCopy'>
                    <TranslatedCopy
                      className='HeaderMenuBook-itemTitle'
                      copyID={ language === 'fr' ? 'HEADER_MYTRIPS_FOURTH_ITEM' : 'APP_UPGRADE'} />
                  </div>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default HeaderMenuMyTrips;
